<crm-single-select
  [options]="options"
  [(selectedItem)]="kind"
  (selectedItemChange)="kindChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  dataKey="name"
  [isTemplateCombined]="true"
  [appendTo]="appendTo"
  [filter]="false">
  <ng-template
    #itemTemplate
    let-type="item">
    {{ type.value | paymentTaskScenarioConditionKindName }}
  </ng-template>
</crm-single-select>
